
import React from 'react';
import { SidebarProvider } from '@/components/ui/sidebar';
import { ThemeProvider } from '@/contexts/ThemeContext';
import { AuthProvider } from '@/contexts/AuthContext';
import { ProxyConfigProvider } from '@/contexts/ProxyConfigContext';
import { useIsMobile } from '@/hooks/use-mobile';
import { AppSidebar } from './AppSidebar';
import { NavBar } from './NavBar';
import FloatingChat from './chat/FloatingChat';

interface MainLayoutProps {
  children: React.ReactNode;
}

export const MainLayout: React.FC<MainLayoutProps> = ({ children }) => {
  const isMobile = useIsMobile();

  return (
    <ThemeProvider>
      <AuthProvider>
        <ProxyConfigProvider>
          <SidebarProvider>
            <div className="min-h-screen flex w-full bg-background">
              <AppSidebar />
              <div className="flex-1 flex flex-col overflow-hidden">
                <NavBar />
                <main className="flex-1 overflow-y-auto p-4 md:p-6">
                  {children}
                </main>
              </div>
              <FloatingChat />
            </div>
          </SidebarProvider>
        </ProxyConfigProvider>
      </AuthProvider>
    </ThemeProvider>
  );
}
